import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="bank-accounts--payment-method-visibility"
// Payment method is a <select> (methodSelect). Show the bank-account block only
// for bank_transfer; reveal the custom payment_type input only for "other".
export default class extends Controller {
  static targets = ["paymentDetail", "methodSelect", "paymentType", "customTypeRow", "customTypeInput"]

  connect() {
    // Quotes hide the whole payment-request block, so methodSelect is absent.
    // No-op there — otherwise toggleStatement("") would d-none the paymentDetail
    // div, which on quotes still holds the (kept) recipient-note row.
    if (!this.hasMethodSelectTarget) return
    const method = this.currentMethod()
    this.toggleStatement(method)
    // Load path: only sync visibility from server-rendered state. Never clear
    // paymentTypeTarget.value here — the ERB seeds it correctly and a stray
    // clear wipes legitimate values (e.g. imported card/paypal).
    this.syncCustomTypeVisibility(method === "other")
  }

  toggle_payment_detail() {
    if (!this.hasMethodSelectTarget) return
    const method = this.currentMethod()
    this.toggleStatement(method)
    this.toggleCustomType(method === "other")
  }

  currentMethod() {
    return this.hasMethodSelectTarget ? this.methodSelectTarget.value : ""
  }

  toggleStatement(method) {
    if (!this.hasPaymentDetailTarget) return
    const shouldShow = method === "bank_transfer"
    this.paymentDetailTarget.classList.toggle("d-none", !shouldShow)
    this.paymentDetailTarget.classList.toggle("d-block", shouldShow)
  }

  // Interactive path only: sync visibility AND clear/sync the hidden payment_type.
  toggleCustomType(isOther) {
    this.syncCustomTypeVisibility(isOther)
    if (isOther) {
      this.syncCustomType()
    } else if (this.hasPaymentTypeTarget) {
      this.paymentTypeTarget.value = ""
    }
  }

  syncCustomTypeVisibility(isOther) {
    if (this.hasCustomTypeRowTarget) this.customTypeRowTarget.classList.toggle("d-none", !isOther)
  }

  syncCustomType() {
    if (this.hasPaymentTypeTarget && this.hasCustomTypeInputTarget) {
      this.paymentTypeTarget.value = this.customTypeInputTarget.value
    }
  }
}
